var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n        opacity: 0\n      }\n\n      .cls-2 {\n        fill: #627ef7\n      }\n\n      .cls-3 {\n        stroke: none\n      }\n\n      .cls-4 {\n        fill: none\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_down_diagonal",
    transform: "translate(-1304 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_924",
    className: "cls-1",
    "data-name": "Rectangle 924"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    className: "cls-3",
    transform: "translate(1304 166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h21v21H.5z",
    className: "cls-4",
    transform: "translate(1304 166)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon_down",
    d: "M5.117 0H3.07v3.07H0v2.047h5.117V0z",
    className: "cls-2",
    transform: "translate(1312.46 174.491)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsed);
export default __webpack_public_path__ + "static/media/collapsed.9440a63d08cc611e9315f7f609070e04.svg";
export { ForwardRef as ReactComponent };